<template>
  <div class="auth-page">
    <div class="auth-page__form">
      <spotley-header/>
      <login-form/>
    </div>
    <div class="auth-page__bg-image"></div>
  </div>
</template>

<script>
import loginForm from '@/components/loginForm.vue';
import spotleyHeader from '@/components/spotleyHeader.vue';

export default {
  name: 'login',
  components: {
    loginForm,
    spotleyHeader,
  },
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.error) {
      this.$toast('error', `Network Error: ${to.query.error.status}`);
      next('login');
    // case where backend call fails and login page 'updates itself'
    } else if (to.name === 'login' && from.name === 'login') {
      this.$toast('error', 'Network Error');
      next('login');
    }
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_globals.scss";
@import "@/assets/scss/wifi-forms.scss";
</style>
